import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SectionModel } from 'data/section/section.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: SectionModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<SectionModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const sectionSlice = createSlice({
  name: 'section',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default sectionSlice;
